import Vue from "vue";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    DatePicker,
  },
  data: function () {
    return {
      saving: false,
      editUuid: null,   // มีค่า = โหมดแก้ไข
      refKeyword: "",
      refResults: [],
      refLoading: false,
      showSuggest: false,
      refDebounce: null,
      // ข้อมูลลูกค้า (prefill จากใบกำกับอ้างอิง — แสดงอย่างเดียว)
      customer: {
        code: "",
        name: "",
        company_name: "",
        phone_number: "",
        tax_id: "",
        address: "",
      },
      // รายการสินค้า — โหลดจากใบอ้างอิงแล้วแก้/ลบ/เพิ่มได้ (โครงเดียวกับ full-tax-create)
      items: [],
      // b-table columns ชุดเดียวกับหน้าสร้างใบกำกับเต็มรูปแบบ
      fields: [
        {
          key: "idx",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
        {
          key: "description",
          label: "รายละเอียด",
          sortable: false,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "20%" },
        },
        {
          key: "length",
          label: "ความยาว",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "quantity",
          label: "จำนวน",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_name",
          label: "หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_length",
          label: "ปริมาณรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_price",
          label: "ราคา/หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_price",
          label: "ราคารวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: false,
          class: "text-right",
          thStyle: { width: "15%" },
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
      ],
      refVatType: 1,  // vat_type ของใบกำกับหลัก (0=ไม่มี VAT, 1=แยก, 2=รวม)
      form: {
        document_no: "",
        document_date: new Date(),
        ref_tax_invoice_id: null,
        ref_document_no: "",
        customer_id: null,
        customer_name: "",
        original_amount: 0,   // มูลค่าตามใบกำกับเดิม (อ้างอิงเฉย ๆ ดึงจากใบ)
        reason: "",
        remark: "",
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.editUuid;
    },
    // มูลค่าลดหนี้ = ผลรวมรายการอัตโนมัติ (ก่อน VAT)
    discountAmount() {
      const sum = this.items.reduce((acc, it) => acc + this.toNum(it.total_price), 0);
      return this.round2(sum);
    },
    // VAT ตาม vat_type ของใบกำกับหลัก: 1=แยก, 2=รวม (ฐานก่อน VAT เท่ากัน) — ใบกำกับเต็มไม่มี type 0
    vatRate() {
      return 7;
    },
    vatAmount() {
      return Math.round(this.discountAmount * this.vatRate) / 100;
    },
    grandTotal() {
      return this.round2(this.discountAmount + this.vatAmount);
    },
  },
  mounted() {
    const uuid = this.$route.params.uuid;
    if (uuid) {
      this.editUuid = uuid;
      this.loadDoc(uuid);
    }
  },
  methods: {
    formatMoney(n) {
      return (Number(n) || 0).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    toNum(v) {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    },
    round2(n) {
      return Math.round((Number(n) || 0) * 100) / 100;
    },

    // วันที่เอกสารเลือกได้ถึงวันนี้ — ห้ามวันอนาคต (เลขเอกสารยึดเดือนจากวันที่)
    disableFutureDates(date) {
      const endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      return date > endOfToday;
    },

    // ===== รายการสินค้า: math ชุดเดียวกับ full-tax-create =====
    computeLine(item) {
      const len = this.toNum(item.length);
      let qtyRaw = this.toNum(item.quantity !== undefined && item.quantity !== null ? item.quantity : item.qty);
      const qty = qtyRaw === 0 ? 1 : qtyRaw;
      const up = this.toNum(item.unit_price);
      const total_length = len > 0 ? this.round2(len * qty) : qty;
      const total_price = this.round2(total_length * up);
      return { total_length, total_price };
    },
    updateTotals(index) {
      const item = this.items[index];
      const { total_length, total_price } = this.computeLine(item);
      item.total_length = total_length;
      item.total_price = total_price;
    },
    lengthChanged(event, index) {
      this.items[index].length = parseFloat(event) || 0;
      this.updateTotals(index);
    },
    quantityChanged(event, index) {
      this.items[index].quantity = parseFloat(event) || 0;
      this.updateTotals(index);
    },
    unitPriceChanged(event, index) {
      this.items[index].unit_price = parseFloat(event) || 0;
      this.updateTotals(index);
    },
    onopenproduct() {
      this.items.push({
        code: "",
        code_description: "",
        description: "",
        length: "0",
        quantity: "0",
        total_length: "0",
        unit_price: "0",
        total_price: "0",
        unit_name: "",
        sku_id: null,
        product_id: null,
      });
    },
    onCopy(index) {
      const t = this.items[index];
      this.items.splice(index + 1, 0, {
        code: t.code,
        code_description: t.code_description,
        description: t.description,
        length: t.length,
        quantity: t.quantity,
        total_length: t.total_length,
        unit_price: t.unit_price,
        total_price: t.total_price,
        unit_name: t.unit_name,
        sku_id: t.sku_id || null,
        product_id: t.product_id || null,
      });
    },
    onRemove(index) {
      if (index >= 0 && index < this.items.length) {
        this.items.splice(index, 1);
      }
    },

    // copy ทุก field จากรายการต้นทางตรง ๆ — ให้เหมือนใบเดิมเป๊ะ (total_price ใช้ค่าที่บันทึกไว้
    // ไม่คำนวณใหม่ตอนโหลด จะคำนวณใหม่เฉพาะตอนผู้ใช้แก้ ความยาว/จำนวน/ราคา — เหมือน full-tax)
    mapItemRow(it) {
      return {
        sku_id: it.sku_id || null,
        product_id: it.product_id || null,
        code: it.code || "",
        code_description: it.code_description || "",
        description: it.description || "",
        length: this.toNum(it.length),
        quantity: this.toNum(it.qty !== undefined && it.qty !== null ? it.qty : it.quantity),
        total_length: this.toNum(it.total_length),
        unit_price: this.toNum(it.unit_price),
        total_price: this.toNum(it.total_price),
        unit_name: it.unit_name || "",
      };
    },

    // โหลดรายการของใบอ้างอิง (backend แปลงเป็นก่อน VAT ให้แล้ว รวมเคสใบรวม VAT)
    async loadRefItems(refId) {
      try {
        const res = await this.$axios.get(`${Vue.prototype.$host}/api/v1/document/credit-note-tax/ref-items/${refId}`);
        const rows = res.data.data || [];
        // vat_type ของใบหลัก → ใช้คิด VAT ให้ตรง (0=ไม่มี VAT)
        this.refVatType = Number(res.data.vat_type ?? 1);
        this.items = rows.map((it) => this.mapItemRow(it));
      } catch (error) {
        this.items = [];
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || "โหลดรายการใบอ้างอิงไม่สำเร็จ");
      }
    },

    setCustomer(cd, fallbackName) {
      this.customer = {
        code: (cd && cd.code) || "",
        name: (cd && cd.name) || "",
        company_name: (cd && cd.company_name) || fallbackName || "",
        phone_number: (cd && cd.phone_number) || "",
        tax_id: (cd && cd.tax_id) || "",
        address: (cd && cd.address) || "",
      };
    },

    // โหลดข้อมูลใบเดิม (โหมดแก้ไข)
    async loadDoc(uuid) {
      try {
        const res = await this.$axios.get(`${Vue.prototype.$host}/api/v1/document/credit-note-tax/${uuid}`);
        const d = res.data.data;
        this.form.document_no = d.document_no || "";
        this.form.document_date = d.document_date ? new Date(d.document_date) : new Date();
        this.form.ref_tax_invoice_id = d.ref_tax_invoice_id;
        this.form.ref_document_no = d.ref_document_no || "";
        this.form.customer_id = d.customer_id;
        this.form.customer_name = d.customer_name || "";
        this.form.original_amount = Number(d.original_amount) || 0;
        this.refVatType = Number(d.vat_type ?? 1); // vat_type ที่บันทึกไว้ (ยึดจากใบหลัก)
        this.form.reason = d.reason || "";
        this.form.remark = d.remark || "";
        this.refKeyword = d.ref_document_no || "";
        this.setCustomer(d.customer_detail, d.customer_name);
        // รายการที่บันทึกไว้ — ใบเก่า (ก่อนมีตารางรายการ) ไม่มี items → สร้างแถวเดียวจากยอดลดเดิม
        const savedItems = Array.isArray(d.items) ? d.items : [];
        if (savedItems.length) {
          this.items = savedItems.map((it) => this.mapItemRow(it));
        } else if (Number(d.diff_amount) > 0) {
          this.items = [{
            sku_id: null, product_id: null, code: "", code_description: "",
            description: "มูลค่าลดหนี้ (ใบเดิมไม่มีรายการ)",
            length: 0, quantity: 1, total_length: 1,
            unit_price: Number(d.diff_amount) || 0, total_price: Number(d.diff_amount) || 0,
            unit_name: "",
          }];
        }
      } catch (error) {
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || "โหลดข้อมูลไม่สำเร็จ");
      }
    },

    // auto-suggest: พิมพ์แล้วยิงค้นหาอัตโนมัติ (debounce 350ms กันยิงถี่)
    onRefInput() {
      this.showSuggest = true;
      if (this.refDebounce) clearTimeout(this.refDebounce);
      const kw = (this.refKeyword || "").trim();
      if (!kw) {
        this.refResults = [];
        this.refLoading = false;
        this.showSuggest = false;
        return;
      }
      this.refLoading = true;
      this.refDebounce = setTimeout(() => this.fetchRef(kw), 350);
    },
    onRefFocus() {
      // เปิด dropdown อีกครั้งถ้ามีคำค้น/ผลเดิม
      if ((this.refKeyword || "").trim() && this.refResults.length) this.showSuggest = true;
    },
    onRefBlur() {
      // หน่วงปิด ให้ทัน mousedown เลือกรายการ (ใช้ @mousedown.prevent ที่ item)
      setTimeout(() => { this.showSuggest = false; }, 150);
    },
    // ค้นหาใบกำกับเต็ม (IV) — endpoint list ของ full-tax (scope สาขาตาม role ที่ backend)
    async fetchRef(kw) {
      try {
        const url = `${Vue.prototype.$host}/api/v1/document/tax-invoice-full?page=1&keyword=${encodeURIComponent(kw)}`;
        const result = await Vue.prototype.$axios.get(url);
        // กันผลเก่ามาทับ (ถ้าคำค้นเปลี่ยนไปแล้ว)
        if ((this.refKeyword || "").trim() !== kw) return;
        this.refResults = result.data.data || [];
      } catch (error) {
        this.refResults = [];
      } finally {
        this.refLoading = false;
      }
    },

    // เลือกใบอ้างอิง → prefill ลูกค้า + มูลค่าเดิม + โหลดรายการของใบมาตั้งต้น
    onSelectRef(iv) {
      this.form.ref_tax_invoice_id = iv.id;
      this.form.ref_document_no = iv.document_no;
      this.form.customer_id = iv.customer_id;
      this.form.customer_name =
        (iv.customer_detail && (iv.customer_detail.company_name || iv.customer_detail.name)) || iv.customer_name || "";
      // มูลค่าตามใบกำกับเดิม = subtotal (ยอดก่อน VAT) — ดึงอัตโนมัติ ผู้ใช้แก้ไม่ได้
      this.form.original_amount = Number(iv.subtotal) || 0;
      this.setCustomer(iv.customer_detail, iv.customer_name);
      // แสดงชื่อใบที่เลือกในช่องค้นหา + ปิด dropdown
      this.refKeyword = iv.document_no;
      this.refResults = [];
      this.showSuggest = false;
      // โหลดรายการของใบอ้างอิงมาตั้งต้น (แก้/ลบ/เพิ่มได้)
      this.loadRefItems(iv.id);
    },

    async onSave() {
      if (!this.form.ref_tax_invoice_id) {
        this.onExceptionHandler("กรุณาเลือกใบกำกับภาษีที่อ้างอิง");
        return;
      }
      if (!this.items.length || this.discountAmount <= 0) {
        this.onExceptionHandler("กรุณาใส่รายการลดหนี้อย่างน้อย 1 รายการ (มูลค่ารวมต้องมากกว่า 0)");
        return;
      }
      if (!this.form.reason) {
        this.onExceptionHandler("กรุณาระบุเหตุผลการลดหนี้");
        return;
      }
      this.saving = true;
      try {
        const payload = {
          ...this.form,
          // มูลค่าลดหนี้ = Σ รายการ (backend คิดจาก items เอง — ส่ง discount_amount เผื่อ compat)
          discount_amount: this.discountAmount,
          items: JSON.stringify(this.items.map((it) => ({
            sku_id: it.sku_id || null,
            product_id: it.product_id || null,
            code: it.code || null,
            code_description: it.code_description || null,
            description: it.description || "",
            qty: this.toNum(it.quantity),
            unit_name: it.unit_name || null,
            unit_price: this.toNum(it.unit_price),
            length: this.toNum(it.length),
            total_length: this.toNum(it.total_length),
            total_price: this.toNum(it.total_price),
          }))),
        };
        if (this.isEdit) {
          await this.$axios.put(`${Vue.prototype.$host}/api/v1/document/credit-note-tax/${this.editUuid}`, payload);
        } else {
          await this.$axios.post(`${Vue.prototype.$host}/api/v1/document/credit-note-tax`, payload);
        }
        this.$router.push("/tax/credit");
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || "บันทึกไม่สำเร็จ";
        this.onExceptionHandler(msg);
      } finally {
        this.saving = false;
      }
    },
  },
};
